export const Utility = {
    secretKey: '123456$#@$^@1ERF'
  };